import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v21A1.5,1.5,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V1.5A1.5,1.5,0,0,0,22.5,0ZM9,9.5a3,3,0,0,1-2.83-2H4.5a1,1,0,0,1,0-2H6.17A3,3,0,1,1,9,9.5Zm1,8a1,1,0,0,1-1,1H4.5a1,1,0,0,1,0-2H9A1,1,0,0,1,10,17.5Zm4.5-3a3,3,0,0,1,2.83,2H19.5a1,1,0,0,1,0,2H17.33a3,3,0,1,1-2.83-4Zm5-7h-5a1,1,0,0,1,0-2h5a1,1,0,0,1,0,2Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }